"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var HelperText = function HelperText(_ref) {
  var status = _ref.status,
      message = _ref.message,
      floating = _ref.floating;
  return message ? /*#__PURE__*/_react.default.createElement(_styles.Span, {
    status: status,
    floating: floating
  }, message) : null;
};

HelperText.defaultProps = {
  message: undefined,
  floating: false
};
var _default = HelperText;
exports.default = _default;